import React, {Component}       from 'react';
import {compose}                from "redux";
import {connect}                from "react-redux";
import {withTranslation}        from "react-i18next";
import {isProperty, setPropertyId, isDefined, userLogout, setPropertyName} from "../../../../../utils/index";
import {history} from "../../../../../utils/history";
import {CONTENT, CONTENT_INFORMATION, LOGIN, MOBILE_LOGIN_SHORT} from "../../../../../constants/appUrls.constants"
import {getPropertyList}         from '../../../../../redux/actions/propertyActions'
import {onCreatePropertySubmit} from "../../../../../redux/actions/createPropertyActions";
import PropertyButtons          from "../../../../organisms/PropertyButtons/PropertyButtons";
import ColAtm                   from "../../../../atomic/Col/Col";
import BlockAtm from "../../../../atomic/Block/Block";
import ButtonAtm from "../../../../atomic/Button/Button";
import { Redirect } from 'react-router-dom';
import {Grid} from "@material-ui/core";
import {PageTitle} from "../../../../atomic/PageHeader/PageTitle";
import PageHeaderAtm from "../../../../atomic/PageHeader/PageHeader";
import {Animated} from "react-animated-css";
import Container from "@material-ui/core/Container";
import LabelAtm from "../../../../atomic/Label/Label";
import {logout,clearState} from "../../../../../redux/actions/userActions";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import {withStyles} from '@material-ui/core/styles';
import Typography from "@material-ui/core/Typography";
import MuiDialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from '@material-ui/icons/Close';
import MuiDialogContent from "@material-ui/core/DialogContent/DialogContent";
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import debounce from 'lodash/debounce';
import ClearIcon from '@material-ui/icons/Clear';
import {Skeleton} from "@material-ui/lab";
import {getProfile} from "../../../../../redux/actions/User/Profile/profileAction";
import {isWebSettingsAllowed} from "../../../Web/WebSettings/allowedEmails";

// Kademeli (progressive) render ayarları — 300+ property tek seferde DOM'a basılmasın diye
const INITIAL_VISIBLE_COUNT = 24;
const LOAD_MORE_CHUNK = 24;

// Durum etiketinin METNI servisten geliyor (status_text). Burada yalnizca rengi
// belirliyoruz. Haritada olmayan bir kod gelirse "neutral" tonuna dusuyor; yani
// servise yeni bir status eklendiginde ekran kirilmiyor, gri olarak gorunuyor.
const STATUS_TONES = {
    1: 'active',    // Aktif
    0: 'closed',    // Kapandı
    7: 'closed',    // Kaybedildi
    2: 'warning',   // Deneme Bitti
    3: 'warning',   // Askıya Alındı
    5: 'neutral',   // Demo
    6: 'neutral',   // Sunum
    99: 'neutral',  // Test
};

const getStatusTone = (status) => STATUS_TONES[Number(status)] || 'neutral';

const ALL_STATUS_FILTER = 'all';

const styles = theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)(props => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon className="close-button" />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

class propertySelect extends Component {

    constructor(props){
        super(props);
        this.state = {
            redirect: false,
            open: false,
            createConfirmOpen: false,
            searchTerm: '',
            debouncedSearchTerm: '',
            statusFilter: ALL_STATUS_FILTER,
            filterMenuOpen: false,
            visibleCount: INITIAL_VISIBLE_COUNT
        };
        this.handleDebouncedSearch = debounce(this.handleDebouncedSearch, 300);

        // Ekrandaki kutu sayısını kaydırmaya göre artıran gözlemci.
        // IntersectionObserver desteklenmiyorsa (çok eski tarayıcı) tüm liste basılır.
        this.sentinelNode = null;
        this.observer = typeof IntersectionObserver !== 'undefined'
            ? new IntersectionObserver(this.handleIntersect, { rootMargin: '400px 0px' })
            : null;
    }

    handleIntersect = (entries) => {
        if (!entries.some(entry => entry.isIntersecting)) {
            return;
        }
        this.setState(prevState => {
            const filteredLength = this.getFilteredList().length;
            if (prevState.visibleCount >= filteredLength) {
                return null;
            }
            return {
                visibleCount: Math.min(prevState.visibleCount + LOAD_MORE_CHUNK, filteredLength)
            };
        });
    };

    // Sentinel div'i mount/unmount oldukça gözlemciye bağla/çöz
    setSentinelRef = (node) => {
        if (!this.observer) {
            return;
        }
        if (this.sentinelNode) {
            this.observer.unobserve(this.sentinelNode);
        }
        this.sentinelNode = node;
        if (node) {
            this.observer.observe(node);
        }
    };

    componentWillUnmount() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    // Yalnizca aramanin uygulandigi liste. Filtre sayaclari bunun uzerinden
    // hesaplanir: her cip "secersem kac tesis kalir" sayisini gosterir.
    getSearchedList = () => {
        const { property_list } = this.props;
        const { debouncedSearchTerm } = this.state;

        if (!property_list || property_list.length === 0) {
            return [];
        }

        return property_list.filter(property =>
            property?.name &&
            property.name.toLocaleLowerCase('tr').includes(debouncedSearchTerm.toLocaleLowerCase('tr'))
        );
    };

    getFilteredList = () => {
        const { statusFilter } = this.state;
        const searched = this.getSearchedList();

        if (statusFilter === ALL_STATUS_FILTER || !this.canUseStatusFilter()) {
            return searched;
        }

        return searched.filter(property => String(property.status) === statusFilter);
    };

    // Filtre kovalarini VERIDEN uretir: hangi durumlar geliyorsa o kadar cip olur.
    // Boylece yeni bir status eklendiginde kod degisikligi gerekmiyor.
    getStatusBuckets = (list) => {
        const buckets = new Map();

        list.forEach((property) => {
            if (!isDefined(property.status_text)) {
                return;
            }
            const key = String(property.status);
            if (!buckets.has(key)) {
                buckets.set(key, {
                    key,
                    text: property.status_text,
                    tone: getStatusTone(property.status),
                    count: 0,
                });
            }
            buckets.get(key).count += 1;
        });

        // En cok kullanilan durum basta dursun
        return Array.from(buckets.values()).sort((a, b) => b.count - a.count);
    };

    canUseStatusFilter = () => isWebSettingsAllowed(this.props.profileEmail);

    handleStatusFilterChange = (key) => {
        // Filtre degisince liste basa sarsin (arama davranisiyla ayni)
        this.setState({ statusFilter: key, visibleCount: INITIAL_VISIBLE_COUNT, filterMenuOpen: false });
    };

    toggleFilterMenu = () => this.setState(prev => ({ filterMenuOpen: !prev.filterMenuOpen }));

    closeFilterMenu = () => this.setState({ filterMenuOpen: false });

    handleClickOpen = () => {
        this.setState({open: true})
    };

    handleClose = () => {
        this.setState({open: false})
    };

    componentDidMount() {
        document.body.style.backgroundColor = "#f4f7fc";
        const {getPropertyList, getProfile} = this.props;
        getPropertyList();
        // Durum etiketi kademeli acilis listesine bagli; e-postayi profilden ogreniyoruz
        getProfile();
        this.setState({ redirect: false });

    }
    handleClick = (e, propertyName) =>{
        e.preventDefault();
        const { clearState } = this.props;
        let id = e.target.value;
        if( isDefined(id) ) {
            setPropertyId(id);
            setPropertyName(propertyName);

            // Otel degisiyor: localStorage yeni oteli gosterirken redux hala
            // oncekinin verisini tutuyor. Bircok reducer PENDING'de eski veriyi
            // koruyor (orn. generalInformationReducer, dashboardReducers,
            // propertyRoomAndRateReducers `...state` ile devam ediyor).
            //
            // NOT: Bu bir savunma, giderilmis bir hata degil. Genel Bilgiler ve
            // Odalar sayfalarinda bayat verinin ekrana bastigi DOGRULANAMADI —
            // ikisi de `fetching` bayragi doluyken icerigi hic render etmiyor.
            // Yine de tum ekranlar icin ayni garantiyi veremedigimizden, otel
            // degisimini logout'la ayni bilinen-iyi duruma indirgiyoruz:
            // giristen sonraki durumun aynisi, uygulama bu hali zaten isliyor.
            clearState();

            isProperty() ? history.push(CONTENT) : history.push("/")
        }
    };

    handleOpenCreateConfirm = (e) => {
        e.preventDefault();
        this.setState({ createConfirmOpen: true });
    };

    handleCloseCreateConfirm = () => {
        this.setState({ createConfirmOpen: false });
    };

    handleCreateProperty = () => {
        this.setState({ createConfirmOpen: false });
        this.props.onCreatePropertySubmit(this.state);
        this.setState({ redirect: true });
    };

    handleSearchChange = (e) => {
        const value = e.target.value;
        this.setState({ searchTerm: value });
        this.handleDebouncedSearch(value);
    }

    handleDebouncedSearch = (value) => {
        this.setState({ debouncedSearchTerm: value });
    }

    // Durum filtresi: arama kutusunun yanindaki dropdown. Etiketle ayni izne bagli.
    renderStatusFilter = (searchedList) => {
        const { t } = this.props;
        const { statusFilter, filterMenuOpen } = this.state;

        if (!this.canUseStatusFilter() || searchedList.length === 0) {
            return null;
        }

        const buckets = this.getStatusBuckets(searchedList);

        // Tek durum varsa filtre anlamsiz
        if (buckets.length <= 1) {
            return null;
        }

        const options = [
            { key: ALL_STATUS_FILTER, text: t('enw-input-all', 'Tümü'), count: searchedList.length },
            ...buckets,
        ];
        const selected = options.find(option => option.key === statusFilter) || options[0];

        return (
            <div
                className="property-toolbar__filter"
                onKeyDown={(event) => { if (event.key === 'Escape') this.closeFilterMenu(); }}
            >
                <button
                    type="button"
                    className={`property-filter-trigger${filterMenuOpen ? ' is-open' : ''}`}
                    onClick={this.toggleFilterMenu}
                    aria-haspopup="listbox"
                    aria-expanded={filterMenuOpen}
                >
                    {selected.tone
                        ? <i className={`property-dot property-dot--${selected.tone}`} />
                        : <i className="fal fa-filter property-filter-trigger__icon" />}
                    <span className="property-filter-trigger__label">{selected.text}</span>
                    <span className="property-filter__count">{selected.count}</span>
                    <i className="fas fa-chevron-down property-filter-trigger__chevron" />
                </button>

                {/* MUI Menu kullanilmiyor: styles.scss'te 960-1600px arasi
                    `body { zoom: 0.8 }` var. MUI Popover konumu getBoundingClientRect
                    ile hesaplayip `position: fixed` uyguluyor; zoom'lu body icinde
                    olcek iki kez islendigi icin menu sola kayiyordu. Tetikleyiciye
                    gore `position: absolute` acilan bu menu zoom'dan etkilenmiyor. */}
                {filterMenuOpen && <div className="property-filter-backdrop" onClick={this.closeFilterMenu} />}

                {/* Kosullu render edilseydi kapanis animasyonu calisamazdi (element
                    aninda unmount olur). DOM'da birakip sinifla aciyoruz; kapaliyken
                    visibility:hidden oldugu icin klavye odagi da gitmiyor. */}
                <ul
                    className={`property-filter-menu${filterMenuOpen ? ' is-open' : ''}`}
                    role="listbox"
                    aria-hidden={!filterMenuOpen}
                >
                    {options.map((option) => (
                        <li key={option.key}>
                            <button
                                type="button"
                                role="option"
                                aria-selected={option.key === statusFilter}
                                tabIndex={filterMenuOpen ? 0 : -1}
                                className={`property-filter-menu__item${option.key === statusFilter ? ' is-selected' : ''}`}
                                onClick={() => this.handleStatusFilterChange(option.key)}
                            >
                                <i className={`property-dot property-dot--${option.tone || 'spacer'}`} />
                                <span className="property-filter-menu__label">{option.text}</span>
                                <span className="property-filter__count">{option.count}</span>
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
        );
    };

    // Tesis durumu etiketi. Metni servis veriyor (status_text); burada yalnizca
    // rengini seciyoruz. Yalnizca kademeli acilis listesindeki hesaplara gorunur.
    renderStatusBadge = (property) => {
        if (!isWebSettingsAllowed(this.props.profileEmail)) {
            return null;
        }

        // Servis metni gondermiyorsa etiket basma
        if (!isDefined(property.status_text)) {
            return null;
        }

        const tone = getStatusTone(property.status);

        return (
            <span className={`property-status property-status--${tone}`}>
                <i className={`property-dot property-dot--${tone}`} />
                {property.status_text}
            </span>
        );
    };

    getPropertyBoxStyle = (property) => (
        property.default_photo === "/assets/img/placeholder.png" ?
            {
                backgroundImage: "url(" + property.default_photo +")",
                backgroundRepeat: 'no-repeat',
                backgroundColor: '#ccced5',
                backgroundPosition: 'center',
                backgroundSize: '38px',
                color: 'transparent',
                borderRadius: '0px',
                borderBottomLeftRadius: '8px',
                borderBottomRightRadius: '8px'
            }
            :
            {
                backgroundImage: "url(" + property.default_photo +")",
                backgroundRepeat: 'round',
                color: 'transparent',
                borderRadius: '0px',
                borderBottomLeftRadius: '8px',
                borderBottomRightRadius: '8px'
            }
    );

    // Tek property + daha önce seçilmemişse otomatik yönlendir
    selectPropertyID = (visibleList) => {
        const { property_list } = this.props;

        if (property_list.length === 0) {
            return null;
        }

        if (property_list.length === 1 && localStorage.getItem("property") === null) {
            const property = property_list[0];
            setPropertyId(property.id);
            setPropertyName(property.name);
            return <Redirect to={CONTENT} />;
        }

        return visibleList.map((property) => (
            property !== null && (
                <ColAtm xs={6} sm={4} md={3} xl={3} key={property.id} value={property.id}>
                    <PropertyButtons
                        blockClassName="property-box"
                        value={property.id}
                        text={property.name}
                        buttontext={property.name}
                        tooltip={property.name}
                        labelClass="property-box__title"
                        className="properties"
                        onClick={(e) => this.handleClick(e, property.name)}
                        badge={this.renderStatusBadge(property)}
                        style={this.getPropertyBoxStyle(property)} />
                </ColAtm>
            )
        ));
    };

    // fetching sırasında / kaydırırken gösterilecek iskelet kutular — gerçek property kartıyla aynı yapı
    renderSkeletons = (count) => (
        Array.from({ length: count }).map((item, key) => (
            <ColAtm xs={6} sm={4} md={3} xl={3} key={`skeleton-${key}`}>
                <div style={{ width: '100%', padding: '0 8px 16px', boxSizing: 'border-box' }}>
                    <div style={{
                        background: '#fff',
                        borderRadius: 8,
                        boxShadow: '0 2px 10px rgba(45, 48, 57, 0.08)',
                        overflow: 'hidden'
                    }}>
                        <div style={{ padding: '16px 16px 12px' }}>
                            <Skeleton variant="text" animation="wave" width="70%" height={20} style={{ borderRadius: 4 }} />
                        </div>
                        <Skeleton variant="rect" animation="wave" width="100%" height={160} />
                    </div>
                </div>
            </ColAtm>
        ))
    );


    renderRedirect = () => {
        if (this.props.create_property.status === 200 && this.state.redirect) {
            localStorage.setItem('property', this.props.property_id);
            return <Redirect to={CONTENT_INFORMATION} />
        }
    };

    logOut = () => {
        const { logout } = this.props;
        logout();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {logoutStatus,clearState} = this.props

        // Arama değiştiğinde görünen kutu sayısını başa sar
        if (prevState.debouncedSearchTerm !== this.state.debouncedSearchTerm) {
            this.setState({ visibleCount: INITIAL_VISIBLE_COUNT });
        }

        if (prevProps.logoutStatus !== logoutStatus ){
            if(logoutStatus === 200){
                clearState()
                userLogout();
                if (isDefined(localStorage.getItem("mobile_login"))) {
                    history.push(MOBILE_LOGIN_SHORT + localStorage.getItem("mobile_login"));
                } else {
                    history.push(LOGIN);
                }
            }
        }
    }

    render() {
        const listCount = this.props.property_list;
        const { t, fetching } = this.props;
        const { open, createConfirmOpen } = this.state;

        const searchedList = this.getSearchedList();
        const filteredList = this.getFilteredList();
        const visibleList = this.observer ? filteredList.slice(0, this.state.visibleCount) : filteredList;
        const hasMore = !!this.observer && this.state.visibleCount < filteredList.length;
        const isLoading = fetching && (!listCount || listCount.length === 0);
        const showSearch = !!listCount && listCount.length > 10;
        const statusFilterNode = isLoading ? null : this.renderStatusFilter(searchedList);

        return (
            <>
                <PageTitle title={ t('enw-select_property-page_title') }  />
                <PageHeaderAtm exitText={ t('btn-exit') }  text={ t('enw-select_property-title') } onClick={this.handleClickOpen}/>
                <Animated animationIn="bounceInRight" animationInDuration={1000} isVisible={true}>
                    <Container maxWidth="xl">
                        <div className="property-container">
                            <BlockAtm>
                                <ColAtm className="justify-center">                                
                                    <LabelAtm style={{paddingBottom: listCount && listCount.length > 10 && 0}}  labelClass="property-label" text={ t('enw-select_property-desc') } />
                                </ColAtm>
                                {   // Arama + durum filtresi tek satirda
                                    (showSearch || statusFilterNode) &&
                                        <ColAtm xs={12} className="property-toolbar">
                                            {showSearch &&
                                                <div className="property-toolbar__search">
                                                    <TextField
                                                        fullWidth
                                                        variant="outlined"
                                                        size="small"
                                                        placeholder={t('btn-search')}
                                                        value={this.state.searchTerm}
                                                        onChange={this.handleSearchChange}
                                                        style={{backgroundColor: '#fff', borderRadius: 8, color: '#2d3039'}}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <SearchIcon style={{color: '#2d3039'}} />
                                                                </InputAdornment>
                                                            ),
                                                            endAdornment: (
                                                                this.state.searchTerm && (
                                                                    <InputAdornment position="end">
                                                                        <IconButton
                                                                            aria-label="clear search"
                                                                            onClick={() => {
                                                                                this.setState({ searchTerm: '', debouncedSearchTerm: '' });
                                                                            }}
                                                                            edge="end"
                                                                            size="small"
                                                                        >
                                                                            <ClearIcon style={{color: '#2d3039'}} />
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                )
                                                            ),
                                                        }}
                                                        inputProps={{
                                                            style: { fontSize: 16, paddingTop: 15, paddingBottom: 15, borderRadius: 8, color:'#2d3039'},
                                                            'aria-label': 'search',
                                                        }}
                                                    />
                                                </div>
                                            }
                                            {statusFilterNode}
                                        </ColAtm>
                                }
                                <Grid
                                    container
                                    direction="row"
                                    justify={listCount.length < 2 ? "center" : "flex-start"}
                                    alignItems="center"
                                >
                                    { isLoading
                                        ? this.renderSkeletons(12)
                                        : this.selectPropertyID(visibleList) }

                                    { !isLoading && listCount.length > 0 && filteredList.length === 0 && (
                                        <div className="property-filter-empty">
                                            { t('enw-notification-no_results', 'Sonuç bulunamadı') }
                                        </div>
                                    )}

                                    { !isLoading && hasMore && (
                                        <>
                                            {this.renderSkeletons(4)}
                                            <div ref={this.setSentinelRef} style={{ width: '100%', height: 1 }} />
                                        </>
                                    )}

                                    { !isLoading && !hasMore && (
                                        <ColAtm xs={6} md={3}>
                                            <BlockAtm className="properties new-property" style={{height: '209px'}}>
                                                <ButtonAtm
                                                    className="properties new-property-btn"
                                                    startIcon={<i className="fas fa-plus" />}
                                                    onClick={this.handleOpenCreateConfirm}
                                                    buttontext={ t('btn-create_a_new_hotel') }
                                                />
                                                {this.renderRedirect()}
                                            </BlockAtm>
                                        </ColAtm>
                                    )}
                                </Grid>
                            </BlockAtm>
                        </div>
                    </Container>
                </Animated>
                <div>
                    <Dialog
                        open={open}
                        onClose={this.handleClose}
                        aria-labelledby="logout-modal"
                        className="logout-modal"
                        disableBackdropClick={true}
                    >
                        <DialogTitle id="logout-modal" className="red-bottom-border" onClose={this.handleClose}>{t('btn-exit')}</DialogTitle>
                        <DialogContent>
                            <DialogContentText className="fs-18 f-w-600">
                                {t('enw-logout_exit-text')}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <ButtonAtm
                                onClick={this.handleClose}
                                className="room-rate-modal-save bg-green m-0-8"
                                type="submit"
                                buttontext={ t('btn-back') }
                                color="primary"
                            />
                            <ButtonAtm
                                onClick={this.logOut}
                                className="room-rate-modal-save bg-red m-0-8"
                                type="submit"
                                buttontext={ t('btn-exit') }
                                color="primary"
                            />
                        </DialogActions>
                    </Dialog>
                </div>
                <div>
                    <Dialog
                        open={createConfirmOpen}
                        onClose={this.handleCloseCreateConfirm}
                        aria-labelledby="create-property-modal"
                        className="logout-modal"
                        disableBackdropClick={true}
                    >
                        <DialogTitle id="create-property-modal" className="red-bottom-border" onClose={this.handleCloseCreateConfirm}>{t('btn-create_a_new_hotel')}</DialogTitle>
                        <DialogContent>
                            <DialogContentText className="fs-18 f-w-600">
                                {t('enw-create_property-confirm_text')}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <ButtonAtm
                                onClick={this.handleCloseCreateConfirm}
                                className="room-rate-modal-save bg-dark-grey m-0-8"
                                type="button"
                                buttontext={ t('btn-go_back') }
                                color="primary"
                            />
                            <ButtonAtm
                                onClick={this.handleCreateProperty}
                                className="room-rate-modal-save bg-green m-0-8"
                                type="submit"
                                buttontext={ t('enw-input-checkbox-yes') }
                                color="primary"
                            />
                        </DialogActions>
                    </Dialog>
                </div>
            </>
        );
    }
}
const mapStateToProps = (props) => {

    return{
        property_list : props.propertyReducer.property_list,
        fetching : props.propertyReducer.fetching,
        create_property : props.createPropertyReducer.create_property,
        property_id : props.createPropertyReducer.property_id,
        logoutStatus : props.userReducer.userLogoutStatus,
        profileEmail : props.profileReducer
            && props.profileReducer.profileData
            && props.profileReducer.profileData.profile
            && props.profileReducer.profileData.profile.email
    }
};


const mapDispatchToProps = {
    onCreatePropertySubmit,
    getPropertyList,
    getProfile,
    logout,
    clearState
};

export default compose(withTranslation('common')) (connect(mapStateToProps, mapDispatchToProps )(propertySelect));
